/**
 * Versión en tarjetas de una tabla para pantallas angostas: título, subtítulo, una cuadrícula
 * de métricas y una acción opcional (p. ej. «Omitir»). La usan las tablas anchas del módulo.
 */
import React from 'react';
import { ink, studio } from '../admin/studioUi';

/**
 * @param {{items: Array, keyOf: function, titleOf: function, subtitleOf?: function,
 *          metricsOf: function, actionOf?: function, empty?: string}} props
 */
export default function MobileCards({ items, keyOf, titleOf, subtitleOf, metricsOf, actionOf, empty = 'Sin datos.' }) {
    if (!items.length) return <p style={{ ...studio.hint, textAlign: 'center', padding: 16 }}>{empty}</p>;
    return (
        <div style={styles.list}>
            {items.map(item => (
                <div key={keyOf(item)} style={styles.card}>
                    <div style={styles.head}>
                        <div style={{ minWidth: 0 }}>
                            <div style={styles.title}>{titleOf(item)}</div>
                            {subtitleOf && <div style={styles.subtitle}>{subtitleOf(item)}</div>}
                        </div>
                        {actionOf && actionOf(item)}
                    </div>
                    <div style={styles.grid}>
                        {metricsOf(item).map(metric => (
                            <div key={metric.label} style={styles.metric}>
                                <span style={styles.label}>{metric.label}</span>
                                <span style={{ ...styles.value, ...(metric.color ? { color: metric.color } : {}) }}>{metric.value}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

const styles = {
    list: { display: 'flex', flexDirection: 'column', gap: 10 },
    card: {
        padding: '12px 14px',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: ink.line,
        borderRadius: 12,
        backgroundColor: ink.surface,
    },
    head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10, marginBottom: 10 },
    title: { fontWeight: 600, color: ink.text, fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
    subtitle: { fontSize: '0.76rem', color: ink.faint, marginTop: 2 },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '8px 10px' },
    metric: { display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0 },
    label: { fontSize: '0.64rem', color: ink.faint, textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    value: { fontSize: '0.9rem', fontWeight: 600, color: ink.text, fontVariantNumeric: 'tabular-nums', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
};
